import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    setUsersPayer,
    setUsersParticipant,
    setCurseHadings,
    setStartDate,
} from '../../reducers/reposReducers';
import ApiService from '../../services/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import NavigationPulpit from '../../pages/summary/navigatorBarSummary/navigationPulpit/navigationPulpit';
import OverduePay from './overduePayments';
import ActiveCourse from './active_cours';
import Wydarzenia from "../../assets/images/egurrola_winter.jpg"
import Warsztaty from "../../assets/images/warsztaty.jpg"
import Vibe from "../../assets/images/Vibe.jpg"
import CustomButtons from "../Elements/Buttons/customButton"
import Calendar from '../calendar/calendar';
import Modal from '../Elements/modal/modal';
import SalesEvent from './salesCalendaryEvent.js'
import axios from 'axios';
import { API_URL } from '../../config';
import './pulpit.css';
const Pulpit = (props) => {
    const [display, setDisplay] = useState(0);
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    
    const apiService = ApiService.getInstance();
    const today = new Date(new Date());
    const date = today.setDate(today.getDate());
    const dispatch = useDispatch();
    const dataSelecrCurse = useDispatch();
    const defaultValue = new Date(date).toISOString().split('T')[0];
    let [modalClassII, showModalII] = useState('modal hidden');
    const payload = {
        keyController: 'localizations',

        current_LocalizationsID: '0',
    };
    const [curseDetails,setCurseDetails] =  useState([])
    const [user, setUser] = useState([]);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [header, setHeader] = useState('');
    const navigationStateII = window.location.href;
    const SendURL = `${API_URL}GetSchedulesEventsSettlements`
    const [formDataHeading] = useState({
        courseHeadingName: useSelector((state) => state.repos.chName), // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${defaultValue}`,
        current_LocalizationsID: '0',
    });
    const [formData, setFromData] = useState({
        startDate: defaultValue,
    });
    const [allLocation, setAllLocation] = useState([]);

    const [selectedLocation, setSelectedLocation] = useState("")
    
    function showModal(day) {
        let requestDay;
        let mounth =  currentDate.getMonth() + 1
        if(mounth < 10){
         
            requestDay = parseInt(currentDate.getFullYear()+"0" + mounth + "" +day)
        }else{
             
            requestDay = parseInt(currentDate.getFullYear()+"" + mounth + "" +day) 
        }
        const courseRequest =  {
            intEventDate: requestDay,
            localizationsID: selectedLocation
        }
        axios
        .post(SendURL, courseRequest, config)
        .then((response) => {

         if(response.data.succeeded){
            setCurseDetails(response.data.schedulesEventsSettlements)
            console.log("kilku")
            if (modalClassII == 'modal hidden') {
                showModalII('modal');
            } else {
                showModalII('modal hidden');
            }
         }
          
        })
        .catch(function (error) {
        console.log(error)
            if (error.response.status == 401) {
                // history.push('/Error_ogolny');
            }
        });
       
    }
    function endModal(){
        showModalII('modal hidden');
    }
    const stepsList = ['Zaległe płatności', 'Aktywne kursy i usługi', 'Kalendarium'];
    const [stepIndex, setStepIndex] = useState(0);

    const getCourseForUser = () => {
        apiService.apiPost('CalculateProductForUser', payload, (response) => {
            if (response.success) {
                setAllLocation(response.data.responseBody.body.body)
               
            }
        });
    };

    useEffect(() => {
        props.setHeader('/  PULPIT');
        getCourseForUser();
    }, []);
    


    return (
        <>
         <div className={modalClassII}>
                <Modal close={endModal}>
                    <div className='showAwaibleEvent'>
                    {curseDetails.length != 0?
                        curseDetails.map((cours)=>{
                          
                            return <SalesEvent name={cours.courseHeadingName} timeFrom={cours.timeFrom} timeTo={cours.timeTo}> </SalesEvent>
                        }):<div className="NoCourseToday"><p  className="titleNoToday">Nie znaleziono zajęć dla wybranych parametrów</p>
                        <p className="msgsNoToday">Spróbuj wybrać inny dzień lub inną lokalizacje</p></div>
                    } 
                       
                    
                     </div>
                </Modal>
            </div>
            <div className="dashboard__content">
                <main>
                    <NavigationPulpit
                        choosen={stepIndex}
                        stepsList={stepsList}
                        onChoosenChange={setStepIndex}
                    ></NavigationPulpit>

                    {stepIndex == 0 ? <OverduePay setMsg={props.setMsg} modalClass={props.modalClass} showModal={props.showModal}  userID={props.userID} /> : ''}
                    {stepIndex == 1 ? (
                        <ActiveCourse userID={props.userID} userName={props.userName} />
                    ) : (
                        ''
                    )}
                    {stepIndex == 2 ? (
                        <div className="courseWrapper CalendaryWraper">
                        <div className="filter_eventList">
                            <p  style={{ color: 'black' }}>Pokaż dla:</p>
                            <select className="select_filterEventList" onChange={(e)=>{setSelectedLocation(e.target.value);}}>
                        
                                {
                                allLocation!= undefined?allLocation.map((location, index) => {
                                  
                                    if(index == 0&&selectedLocation == ""){
                                        
                                        setSelectedLocation(location.localizationsID)
                                    }
                                    return <option key={index +""+index} value={location.localizationsID}>{location.localizationName}</option>
                                }):""  
                                }
                            </select>
                        </div>
                            <div  className="courseWrapper_row marginCourseCalendary">
                            <Calendar
                                user={user}
                                value={currentDate}
                                onChange={setCurrentDate}
                                filter={true}
                                setHeader={setHeader}
                                localization={navigationStateII}
                                changeModal={showModal}
                                isInside={true}
                            />
                           
                         
                   </div>
                       <a target="_blank"  href="http://egurrola.com/wydarzenia/"className="courseMore_link margin-top-32 "  >
                               
                               <CustomButtons clickFunction={()=>{console.log("")}} classButton="solid" size="big">
                       Zobacz pełną ofertę
                               </CustomButtons>
                           </a>
                               
                                
                          
                            
                        </div>
                    ) : (
                        ''
                    )}
                </main>
            </div>
        </>
    );
};

export default Pulpit;
